import { useMutation } from "@apollo/client";
import { useEffect } from "react";

import { useUserContext } from "../../../contexts/UserContext";
import { UserActionTypes } from "../../../contexts/reducers/userReducer";
import { LoginMutation } from "../../../graphql/deliveryService/mutations/login";
import { AccessFragment } from "../../../models/autogenerated-deliveryService-gql/graphql";

interface LoginMutationProps {
  dataAction?: (data: AccessFragment) => void;
  errorAction?: () => void;
}

const useLoginMutation = (props: LoginMutationProps) => {
  const { dispatchUser } = useUserContext();

  const { dataAction, errorAction } = props;

  const mutation = useMutation(LoginMutation, {});

  const { data, error } = mutation[1];

  const loginFragment = data?.access.accessOutput;

  useEffect(() => {
    if (!error) return;

    errorAction && errorAction();
  }, [error]);

  useEffect(() => {
    if (!data || !loginFragment) return;

    dispatchUser({
      type: UserActionTypes.Login,
      value: loginFragment,
    });

    dataAction && dataAction(loginFragment);
  }, [data]);

  return mutation;
};

export default useLoginMutation;
